import { Component, OnInit } from '@angular/core';
import { Agreement } from '../../../model/agreement';

@Component({
  selector:    'app-cards',
  templateUrl: './cards.component.html',
  styleUrls:   [ './cards.component.scss' ]
})
export class CardsComponent implements OnInit {
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/cards/cards.component.ts